<template>
  <div class="lesson-window-alert centered">
    <p class="lighten text-center" v-html="message"></p>
    <v-btn
      v-if="link"
      class="mt-2"
      color="primary"
      depressed
      rounded
      @click="click"
    >{{ $t('openLink') }}</v-btn>
  </div>
</template>

<script>
export default {
  props: ['icon', 'message', 'link'],
  methods: {
    click() {
      const win = window.open(this.link, '_blank');
      win.focus();
    },
  },
};
</script>

<style lang="scss">
.lesson-window-alert {
  width: 100%;
  background: white;
  height: auto;
  flex-direction: column;
  @media only screen and (max-width: 1468px) {
    height: 250px !important;
  }
  &__button {
    min-width: 200px !important;
    max-height: 200px !important;
  }
  &__icon {
    border-radius: 150px;
    background-color: #f5f5fb;
  }
}
</style>
